import { render, staticRenderFns } from "./PriceTag.vue?vue&type=template&id=1e9b9c18&"
import script from "./PriceTag.vue?vue&type=script&lang=js&"
export * from "./PriceTag.vue?vue&type=script&lang=js&"
import style0 from "./PriceTag.vue?vue&type=style&index=0&id=1e9b9c18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports